import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectService } from '../../services/project.service';
import { ConsultationService } from '../../services/consultation.service';
import { ServiceItem } from '../../models/project.model';

@Component({
  selector: 'app-services',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './services.component.html',
  styleUrl: './services.component.scss'
})
export class ServicesComponent {
  private projectService = inject(ProjectService);
  private consultationService = inject(ConsultationService);

  services = this.projectService.services;
  activeServiceId = signal<string | null>(null);

  openServiceModal(serv: ServiceItem) {
    this.activeServiceId.set(serv.id);
  }

  closeServiceModal() {
    this.activeServiceId.set(null);
  }

  bookServiceConsultation(servTitle: string) {
    this.closeServiceModal();
    this.consultationService.openModal({ projectType: servTitle });
  }

  scrollToProjects() {
    this.closeServiceModal();
    const el = document.getElementById('projects');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
